// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Page Transition Animations */
.page-transition {
  position: relative;
}

.page-transition > * {
  animation: fadeIn 0.3s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Smooth transitions for theme changes */
* {
  transition: background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease;
}

/* Card hover effects */
.card-hover-effect {
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.card-hover-effect:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}

/* Button hover animations */
.button-hover {
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
}

.button-hover::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  transform: translate(-50%, -50%);
  transition: width 0.6s ease, height 0.6s ease;
}

.button-hover:hover::after {
  width: 200%;
  height: 200%;
}

/* Input focus effects */
.input-focus-effect {
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.input-focus-effect:focus {
  border-color: #0d9488;
  box-shadow: 0 0 0 3px rgba(13, 148, 136, 0.1);
}

/* Loading skeleton animation */
@keyframes shimmer {
  0% {
    background-position: -1000px 0;
  }
  100% {
    background-position: 1000px 0;
  }
}

.skeleton-loading {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 1000px 100%;
  animation: shimmer 2s infinite linear;
}

/* Dropdown menu animations */
.dropdown-menu {
  transform-origin: top;
  animation: dropdownFade 0.2s ease-in-out;
}

@keyframes dropdownFade {
  from {
    opacity: 0;
    transform: scaleY(0.95);
  }
  to {
    opacity: 1;
    transform: scaleY(1);
  }
}

/* Toast notifications */
.toast-enter {
  animation: toastSlide 0.3s ease-out;
}

@keyframes toastSlide {
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
} `, "",{"version":3,"sources":["webpack://./src/styles/transitions.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B;EACE,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,yCAAyC;AACzC;EACE,+EAA+E;AACjF;;AAEA,uBAAuB;AACvB;EACE,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,kBAAkB;EAClB,gCAAgC;EAChC,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,wBAAwB;AACxB;EACE,wDAAwD;AAC1D;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,+BAA+B;AAC/B;EACE;IACE,8BAA8B;EAChC;EACA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,yEAAyE;EACzE,4BAA4B;EAC5B,qCAAqC;AACvC;;AAEA,6BAA6B;AAC7B;EACE,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE;IACE,UAAU;IACV,uBAAuB;EACzB;EACA;IACE,UAAU;IACV,oBAAoB;EACtB;AACF;;AAEA,wBAAwB;AACxB;EACE,mCAAmC;AACrC;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF","sourcesContent":["/* Page Transition Animations */\n.page-transition {\n  position: relative;\n}\n\n.page-transition > * {\n  animation: fadeIn 0.3s ease-in-out;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Smooth transitions for theme changes */\n* {\n  transition: background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease;\n}\n\n/* Card hover effects */\n.card-hover-effect {\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.card-hover-effect:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);\n}\n\n/* Button hover animations */\n.button-hover {\n  position: relative;\n  overflow: hidden;\n  transition: all 0.3s ease;\n}\n\n.button-hover::after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 0;\n  height: 0;\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 50%;\n  transform: translate(-50%, -50%);\n  transition: width 0.6s ease, height 0.6s ease;\n}\n\n.button-hover:hover::after {\n  width: 200%;\n  height: 200%;\n}\n\n/* Input focus effects */\n.input-focus-effect {\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.input-focus-effect:focus {\n  border-color: #0d9488;\n  box-shadow: 0 0 0 3px rgba(13, 148, 136, 0.1);\n}\n\n/* Loading skeleton animation */\n@keyframes shimmer {\n  0% {\n    background-position: -1000px 0;\n  }\n  100% {\n    background-position: 1000px 0;\n  }\n}\n\n.skeleton-loading {\n  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);\n  background-size: 1000px 100%;\n  animation: shimmer 2s infinite linear;\n}\n\n/* Dropdown menu animations */\n.dropdown-menu {\n  transform-origin: top;\n  animation: dropdownFade 0.2s ease-in-out;\n}\n\n@keyframes dropdownFade {\n  from {\n    opacity: 0;\n    transform: scaleY(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: scaleY(1);\n  }\n}\n\n/* Toast notifications */\n.toast-enter {\n  animation: toastSlide 0.3s ease-out;\n}\n\n@keyframes toastSlide {\n  from {\n    transform: translateY(100%);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
